import React from "react";
import Folder from "./Folder";

import { Routes, Route } from "react-router-dom";

function App({ data, forceRender }) {
  const RouteGenerator = ({ route }) => {
    const { name, path, folders } = route;

    const routesComponents = folders?.map((route, key) => {
      const { id } = route;
      return (
        <Route
          path={`/${id}/*`}
          element={<RouteGenerator route={route} />}
          key={id}
        />
      );
    });
    return (
      <Routes>
        <Route
          path={"/"}
          element={
            <Folder name={name} data={route} forceRender={forceRender} />
          }
          key={path}
        />
        {routesComponents}
      </Routes>
    );
  };

  const routeComponents = data.map((route, key) => {
    const { id } = route;
    return (
      <Route
        path={`/${id}/*`}
        element={<RouteGenerator route={route} />}
        key={id}
      />
    );
  });

  return (
    <Routes>
      <Route
        path={`/`}
        element={<Folder data={data} first forceRender={forceRender} />}
        data={data}
        key={"folder"}
      />
      {routeComponents}
    </Routes>
  );
}

export default App;
